import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';

const POWERBI_EMBED_URL = process.env.REACT_APP_POWERBI_EMBED_URL;

const mapStateToProps = state => ({ views_permissions: state.App.Permissions.views_permissions });

export default connect(mapStateToProps, null)(checkPermissionsHOC(class Dashboard extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://Dashboard/Dashboard'];
        if (!view_parent_access || !POWERBI_EMBED_URL) {
            return <NotFound />;
        }
        return (
            <Container className="dashboard">
                <Row>
                    <div style={{ margin: 0, padding: 0, overflow: 'hidden' }}>
                        <iframe
                            title="Dashboard"
                            ref={this.iframeRef}
                            src={POWERBI_EMBED_URL}
                            frameBorder="0"
                            style={{
                                verticalAlign: 'top', overflow: 'hidden', overflowX: 'hidden', overflowY: 'hidden', height: '110%', width: '94%', position: 'absolute', top: 90, left: 70, right: 0, bottom: 0, background: '#f2f4f7',
                            }}
                            height="110%"
                            width="94%"
                        />
                    </div>
                    <div className="hideReportBar">&nbsp;</div>
                </Row>
            </Container>
        );
    }
}, ['view://Dashboard/Dashboard']));



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Dashboard/index.js